module.exports = __webpack_public_path__ + "static/media/bot_icon.50043163.png";